module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst additionalClasses = []\nconst fromButtonAdditionalClasses = []\nconst toButtonAdditionalClasses = []\nif(fieldConfig.slim)                additionalClasses.push('slim');\nif(fieldConfig.slimTime)            additionalClasses.push('slim time');\nif(fieldConfig.frameLess)           additionalClasses.push('frameLess');\nif(model.dateFrom === null)         fromButtonAdditionalClasses.push('active');\nif(model.dateTo === null)           toButtonAdditionalClasses.push('active');\nconst separatedFieldCodes = fieldConfig.separatedFieldCodes || {}\nif(model.visibilityByFieldCode){\nconst fromFieldCode = separatedFieldCodes.from\nif(fromFieldCode && !model.visibilityByFieldCode[fromFieldCode]){\nadditionalClasses.push('fromInvisible')\n}\nconst toFieldCode = separatedFieldCodes.to\nif(toFieldCode && !model.visibilityByFieldCode[toFieldCode]){\nadditionalClasses.push('toInvisible')\n}\n}\nif(fieldConfig.additionalClasses){\nadditionalClasses.push(fieldConfig.additionalClasses)\n}\nif(fieldConfig.limitBy24Hours){\nadditionalClasses.push('limitBy24Hours')\n}\nif(fieldConfig.alignLeft){\nadditionalClasses.push('alignLeft')\n}\nif(fieldConfig.alignRight){\nadditionalClasses.push('alignRight')\n}\n%><div class=\"<%= additionalClasses.join(' ') %>\">\n<div class=\"from\">\n<% if(fieldConfig.showInfinityButtons !== false){ %>\n<button class=\"from <%= fromButtonAdditionalClasses.join(' ') %>\" tabindex=\"-1\" <%- config.disabled || (fieldConfig.from || {}).disabled ? 'disabled=\"disabled\"' : ''%>>\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-left-stop onLimited\"></i>\n</button>\n<% } %>\n<% if(fieldConfig.useDateAndTimePicker){ %>\n<%- include('./air-date-and-time-picker', { model: { dataDATE: model.dateFrom, fieldCode: \"from\", titleKey: \"form.fields.periodAir.from.title\", config: fieldConfig.from || {}}}) %>\n<% } else { %>\n<%- include('./air-datetime-picker', { model: { dataDATE: model.dateFrom, fieldCode: \"from\", titleKey: \"form.fields.periodAir.from.title\", config: fieldConfig.from || {} }, config: fieldConfig.from || {}}) %>\n<% } %>\n</div>\n<div class=\"center\">\n<div class=\"fromLabel\">von</div>\n<div class=\"toLabel\">bis</div>\n</div>\n<div class=\"to\">\n<% if(fieldConfig.useDateAndTimePicker){ %>\n<%- include('./air-date-and-time-picker', { model: { dataDATE: model.dateToGUI, fieldCode: \"to\", titleKey: \"form.fields.periodAir.to.title\", config: fieldConfig.to || {}}}) %>\n<% } else { %>\n<%- include('./air-datetime-picker', { model: { dataDATE: model.dateToGUI, fieldCode: \"to\", titleKey: \"form.fields.periodAir.to.title\", config: fieldConfig.to || {} }, config: fieldConfig.to || {}}) %>\n<% } %>\n<% if(fieldConfig.showInfinityButtons !== false){ %>\n<button class=\"to <%= toButtonAdditionalClasses.join(' ') %>\" tabindex=\"-1\" <%- config.disabled || (fieldConfig.to || {}).disabled ? 'disabled=\"disabled\"' : ''%>>\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-right-stop onLimited\"></i>\n</button>\n<% } %>\n</div><%\nif(separatedFieldCodes.duration){\n%><div class=\"duration\"><%\n%><%- include('./text', { model: { dataFLOAT: model.duration, atom: { dataType: 'float' }, fieldCode: 'duration', titleKey: \"form.fields.periodAir.duration.title\", config: fieldConfig.duration || {}}}) %><%\nif(fieldConfig.duration.showSetZeroButton !== false){\n%><button class=\"duration setZero\" tabindex=\"-1\" <%- config.disabled || (fieldConfig.duration || {}).disabled ? 'disabled=\"disabled\"' : ''%>><%\n%><i class=\"fi fi-0\"></i><%\n%></button><%\n}\n%></div><%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\period-air.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const additionalClasses = []
const fromButtonAdditionalClasses = []
const toButtonAdditionalClasses = []
if(fieldConfig.slim)                additionalClasses.push('slim');
if(fieldConfig.slimTime)            additionalClasses.push('slim time');
if(fieldConfig.frameLess)           additionalClasses.push('frameLess');
if(model.dateFrom === null)         fromButtonAdditionalClasses.push('active');
if(model.dateTo === null)           toButtonAdditionalClasses.push('active');
const separatedFieldCodes = fieldConfig.separatedFieldCodes || {}
if(model.visibilityByFieldCode){
const fromFieldCode = separatedFieldCodes.from
if(fromFieldCode && !model.visibilityByFieldCode[fromFieldCode]){
additionalClasses.push('fromInvisible')
}
const toFieldCode = separatedFieldCodes.to
if(toFieldCode && !model.visibilityByFieldCode[toFieldCode]){
additionalClasses.push('toInvisible')
}
}
if(fieldConfig.additionalClasses){
additionalClasses.push(fieldConfig.additionalClasses)
}
if(fieldConfig.limitBy24Hours){
additionalClasses.push('limitBy24Hours')
}
if(fieldConfig.alignLeft){
additionalClasses.push('alignLeft')
}
if(fieldConfig.alignRight){
additionalClasses.push('alignRight')
}

    ; __line = 34
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"from\">\n")
    ; __line = 36
    ;  if(fieldConfig.showInfinityButtons !== false){ 
    ; __append("\n<button class=\"from ")
    ; __line = 37
    ; __append(escapeFn( fromButtonAdditionalClasses.join(' ') ))
    ; __append("\" tabindex=\"-1\" ")
    ; __append( config.disabled || (fieldConfig.from || {}).disabled ? 'disabled="disabled"' : '')
    ; __append(">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-left-stop onLimited\"></i>\n</button>\n")
    ; __line = 41
    ;  } 
    ; __append("\n")
    ; __line = 42
    ;  if(fieldConfig.useDateAndTimePicker){ 
    ; __append("\n")
    ; __line = 43
    ; __append( include('./air-date-and-time-picker', { model: { dataDATE: model.dateFrom, fieldCode: "from", titleKey: "form.fields.periodAir.from.title", config: fieldConfig.from || {}}}) )
    ; __append("\n")
    ; __line = 44
    ;  } else { 
    ; __append("\n")
    ; __line = 45
    ; __append( include('./air-datetime-picker', { model: { dataDATE: model.dateFrom, fieldCode: "from", titleKey: "form.fields.periodAir.from.title", config: fieldConfig.from || {} }, config: fieldConfig.from || {}}) )
    ; __append("\n")
    ; __line = 46
    ;  } 
    ; __append("\n</div>\n<div class=\"center\">\n<div class=\"fromLabel\">von</div>\n<div class=\"toLabel\">bis</div>\n</div>\n<div class=\"to\">\n")
    ; __line = 53
    ;  if(fieldConfig.useDateAndTimePicker){ 
    ; __append("\n")
    ; __line = 54
    ; __append( include('./air-date-and-time-picker', { model: { dataDATE: model.dateToGUI, fieldCode: "to", titleKey: "form.fields.periodAir.to.title", config: fieldConfig.to || {}}}) )
    ; __append("\n")
    ; __line = 55
    ;  } else { 
    ; __append("\n")
    ; __line = 56
    ; __append( include('./air-datetime-picker', { model: { dataDATE: model.dateToGUI, fieldCode: "to", titleKey: "form.fields.periodAir.to.title", config: fieldConfig.to || {} }, config: fieldConfig.to || {}}) )
    ; __append("\n")
    ; __line = 57
    ;  } 
    ; __append("\n")
    ; __line = 58
    ;  if(fieldConfig.showInfinityButtons !== false){ 
    ; __append("\n<button class=\"to ")
    ; __line = 59
    ; __append(escapeFn( toButtonAdditionalClasses.join(' ') ))
    ; __append("\" tabindex=\"-1\" ")
    ; __append( config.disabled || (fieldConfig.to || {}).disabled ? 'disabled="disabled"' : '')
    ; __append(">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-right-stop onLimited\"></i>\n</button>\n")
    ; __line = 63
    ;  } 
    ; __append("\n</div>")
    ; __line = 64
    ; 
if(separatedFieldCodes.duration){

    ; __line = 66
    ; __append("<div class=\"duration\">")
    ; 

    ; __line = 67
    ; __append( include('./text', { model: { dataFLOAT: model.duration, atom: { dataType: 'float' }, fieldCode: 'duration', titleKey: "form.fields.periodAir.duration.title", config: fieldConfig.duration || {}}}) )
    ; 
if(fieldConfig.duration.showSetZeroButton !== false){

    ; __line = 69
    ; __append("<button class=\"duration setZero\" tabindex=\"-1\" ")
    ; __append( config.disabled || (fieldConfig.duration || {}).disabled ? 'disabled="disabled"' : '')
    ; __append(">")
    ; 

    ; __line = 70
    ; __append("<i class=\"fi fi-0\"></i>")
    ; 

    ; __line = 71
    ; __append("</button>")
    ; 
}

    ; __line = 73
    ; __append("</div>")
    ; 
}

    ; __line = 75
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\period-air.ejs

}